export default {
  installed: 'Installiert',
  notInstalled: 'Addons ist nicht installiert',
  addons: 'Addons'
}
